import React, { useEffect, useState, useRef } from 'react';
import PendingFG from '../images/FG-pending.png';
import PendingAH from '../images/AH-pending.png';
import { useNavigate } from 'react-router-dom';
import Viewer from 'viewerjs';
import CollectionListViewer from '../components/CollectionListViewer';
import { removeRightClick } from '../utilities/util';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const TOOLTIP_ELEMENTS = Object.freeze({
	COLLECTION: 'Ver colección',
	ZOOM_IN: 'Acercar',
	ZOOM_OUT: 'Alejar',
	ONE_TO_ONE: 'Tamaño real',
	RESET: 'Restablecer',
	PREV: 'Anterior',
	NEXT: 'Siguiente',
	ROTATE_LEFT: 'Rotar a la izquierda',
	ROTATE_RIGHT: 'Rotar a la derecha',
	FLIP_HORIZONTAL: 'Voltear horizontalmente',
	FLIP_VERTICAL: 'Voltear verticalmente',
});

export default function GLIFOSImageViewer(props) {
	const { images, alts, apiService, isadg, itemInfo } = props;
	const imageRef = useRef(null);
	const viewerRef = useRef(null);
	const navigate = useNavigate();
	//const viewerRef = useRef(null);
	const [collection, setCollection] = useState({
		isLoading: true,
		payload: {},
	});
	const [selectedImages, setSelectedImages] = useState({
		isLoading: false,
		payload: {
			selected: null,
			collections: [],
			result_header: null,
		},
	});
	const [page, setPage] = useState(1);
	useEffect(() => {
		viewerRef.current = new Viewer(imageRef.current, {
			inline: true,
			toolbar: {
				...(itemInfo?.ancestors?.root
					? {
							collection: () => {
								document
									.getElementById('collections-list')
									.classList.toggle('show');
								document
									.getElementById('collections-list-info')
									.classList.toggle('show');
							},
					  }
					: {}),
				zoomIn: { show: 1, size: 'large', dataTip: 'Acercar' },
				zoomOut: { show: 1, size: 'large' },
				oneToOne: { show: 1, size: 'large' },
				reset: { show: 1, size: 'large' },
				prev: { show: itemInfo?.prevSibling !== null, size: 'large' },
				play: {
					show: false,
					size: 'large',
				},
				next: {
					show: itemInfo?.nextSibling !== null,
					size: 'large',
				},
				rotateLeft: { show: 1, size: 'large' },
				rotateRight: { show: 1, size: 'large' },
				flipHorizontal: { show: 1, size: 'large' },
				flipVertical: { show: 1, size: 'large' },
			},
			navbar: false,
			className: 'image-viewer',
			minHeight: document.getElementById('gdac830').clientHeight,
			//minWidth: 'auto',
			/* viewed() {
				viewerContainerRef.current.zoomTo(1);
			},
			update() {
				viewerContainerRef.current.update();
			}, */
		});
		viewerRef.current.show();

		// Centrar la imagen en el contenedor
		/* imageRef.current.onload = () => {
			viewerRef.current.zoomTo(1); // Restablecer el zoom al valor original
			const imageWidth = viewerRef.current.getImageWidth(); // Obtener el ancho de la imagen
			const containerWidth = viewerRef.current.getContainerWidth(); // Obtener el ancho del contenedor
			viewerRef.current.zoomTo(containerWidth / imageWidth); // Ajustar el zoom para que la imagen llene el contenedor
			viewerRef.current.zoomTo(1, { x: 0.5, y: 0.5 }); // Centrar la imagen en el contenedor
		}; */

		return () => {
			viewerRef.current.destroy();
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const image = imageRef.current;
		const ViwerLoaded = () => {
			const toolbar = document.querySelector('.viewer-toolbar > ul');
			//console.log(toolbar.children);
			if (toolbar) {
				Array.from(toolbar.children).forEach((element) => {
					const first_class = element.classList[0];
					const id = first_class.replace('viewer-', '');
					const tooltip_value =
						TOOLTIP_ELEMENTS[
							id.replaceAll('-', '_').toUpperCase()
						] ?? '';
					element.setAttribute('data-title', tooltip_value);
					element.setAttribute('id', id);
					if (tooltip_value)
						tippy(`#${id}`, {
							content: tooltip_value,
						});
					if (id === 'prev') {
						element.addEventListener('click', () => {
							if (itemInfo?.prevSibling)
								navigate(
									`/glifos/item/${itemInfo.prevSibling}`
								);
						});
					}
					if (id === 'next') {
						element.addEventListener('click', () => {
							if (itemInfo?.nextSibling)
								navigate(
									`/glifos/item/${itemInfo.nextSibling}`
								);
						});
					}
				});
			}
		};

		image.addEventListener('viewed', ViwerLoaded);

		return () => {
			image.removeEventListener('viewed', ViwerLoaded);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		try {
			if (!itemInfo?.ancestors?.code) return;
			setSelectedImages((prevCollection) => ({
				...prevCollection,
				isLoading: true,
			}));
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.includes('GT-CIRMA-FG')
							? 'CIRMA-FG'
							: 'CIRMA-AH',
						isadg: itemInfo?.ancestors?.code ?? isadg,
						page,
					},
				},
				{},
				(_, rdata) => {
					//console.log(page, rdata);
					const colls = Array.isArray(rdata?.collections)
						? rdata.collections
						: [rdata?.collections];
					setSelectedImages((prevCollection) => ({
						...prevCollection,
						isLoading: false,
						payload: {
							selected: prevCollection?.payload?.selected ?? 0,
							collections: [
								...prevCollection?.payload?.collections,
								...colls,
							],
							result_header: rdata.result_header,
						},
					}));
				}
			);
		} catch (e) {
			//console.log(e);
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		}
		return () => {
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		};
	}, [itemInfo, apiService, isadg, page]);

	useEffect(() => {
		try {
			if (!itemInfo?.ancestors?.root) return;
			if (collection.isLoading)
				apiService.getCollection(
					{},
					{ isadg: itemInfo.ancestors.root },
					(_, rdata) => {
						setCollection({ isLoading: false, payload: rdata });
						//console.log('loaded', rdata);
					}
				);
		} catch (e) {
			//console.log(e);
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		}
		return () => {
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		};
	}, [apiService, itemInfo, collection.isLoading]);

	useEffect(() => {
		viewerRef.current.update();
		if (
			selectedImages.payload?.result_header?.pagination?.total_pages >
			page
		)
			setPage((prevPage) => prevPage + 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedImages.payload.collections]);

	return (
		<>
			<ul id='images' ref={imageRef} onContextMenu={removeRightClick}>
				{selectedImages.payload.collections.length > 0 &&
					selectedImages.payload.collections.map((img, indx) => {
						//console.log('img', img);
						return (
							<li
								key={indx}
								onContextMenu={removeRightClick}
								onMouseDown={() => alert('asdfa')}
							>
								<img
									src={
										img?.thumbnail !== 'NULL'
											? img?.thumbnail
											: isadg?.includes('GR-CIRMA-FG')
											? PendingFG
											: PendingAH
									}
									alt={img?.title ?? ''}
									onContextMenu={removeRightClick}
									onMouseDown={() => alert('asdfa')}
								/>
							</li>
						);
					})}
				{selectedImages.payload.collections.length === 0 && (
					<li
						onContextMenu={removeRightClick}
						onMouseDown={() => alert('asdfa')}
					>
						<img
							src={images[0]}
							alt={alts[0] ?? ''}
							onContextMenu={removeRightClick}
							onMouseDown={() => alert('asdfa')}
						/>
					</li>
				)}
			</ul>
			{/* <ul id='images' ref={viewerContainerRef}>
				{images.map((img, indx) => {
					console.log('img', img);
					return (
						<li key={indx}>
							<img src={img} alt={alts[indx] ?? ''} />
						</li>
					);
				})}
			</ul> */}
			<CollectionListViewer
				collection={collection}
				apiService={apiService}
				isadg={isadg}
				img={images[0]}
			/>
		</>
	);
}
